import Vue from 'vue'
import VueRouter from 'vue-router'
import Overview from '../views/Overview.vue'
import Affiliate from '../views/Affiliate.vue'
import Billing from '../views/Billing.vue'
import Plans from '../views/Plans.vue'
import ConfirmEmail from '../email/ConfirmEmail.vue'
import LoginHistory from "@/views/LoginHistory.vue"
import Api from "@/views/Api.vue"
import Cookies from 'js-cookie'
import AuthErrorComponents from '@/components/auth/authErrorс/AuthErrorComponents.vue'
import Auth from '@/views/Auth.vue'
import AuthForgotPassword from '@/components/auth/forgotPassword/AuthForgotPassword.vue'
import AuthResetPasswordSuccess from '@/components/auth/resetPassword/AuthResetPasswordSuccess.vue'
import AuthResetPassword from '@/components/auth/resetPassword/AuthResetPassword.vue'
import AuthRegistration from '@/components/auth/registration/AuthRegistration.vue'
import AuthLogin from '@/components/auth/login/AuthLogin.vue'
import AuthTwoFa from '@/components/auth/auth2Fa/AuthTwoFa.vue'

Vue.use(VueRouter)

const ifAuthenticated = async (to, from, next) => {
    if (Cookies.get('dolphinAntyAccessToken')) {
      return next()
    } else {
      return next('/auth/login')
  }
}
const haveAccessToOverview = async (to, from, next) => {
  const firstVisit = window.location.href.includes('verified=1')
  const confirmToken = localStorage.getItem('confirmToken')

  if (Cookies.get('dolphinAntyAccessToken') || (firstVisit && confirmToken)) {
    return next()
  } else {
    return next('/auth/login')
  }
}

const ifNotAuthenticated = (to, from, next) => {
  const isEmailConfirmed = localStorage.getItem('isEmailConfirmed')
    ? JSON.parse(localStorage.getItem('isEmailConfirmed'))
    : false;

  if (!Cookies.get('dolphinAntyAccessToken')) {
    return next()
  }

  if (Cookies.get('dolphinAntyAccessToken') && !isEmailConfirmed) {
    return next()
  }

  return next('/')
}

const routes = [
  {
    path: '/',
    redirect: { name: 'Overview' },
    beforeEnter: haveAccessToOverview
  },
  {
    path: '/overview',
    name: 'Overview',
    component: Overview,
    beforeEnter: haveAccessToOverview
  },
  {
    path: '/affiliate-program',
    name: 'Affiliate',
    component: Affiliate,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/billing',
    name: 'Billing',
    component: Billing,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/login-history',
    name: 'LoginHistory',
    component: LoginHistory,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/payment',
    name: 'Plans',
    component: Plans,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/capitalist/result/success',
    redirect: { name: 'Overview', query: { paymentResult: 'success' } },
    beforeEnter: ifAuthenticated
  },
  {
    path: '/unlimint/success',
    redirect: { name: 'Overview', query: { paymentResult: 'success' } },
    beforeEnter: ifAuthenticated
  },
  {
    path: '/unlimint/cancel',
    redirect: { name: 'Overview', query: { paymentResult: 'cancel' } },
    beforeEnter: ifAuthenticated
  },
  {
    path: '/unlimint/inprocess',
    redirect: { name: 'Overview', query: { paymentResult: 'inprocess' } },
    beforeEnter: ifAuthenticated
  },
  {
    path: '/unlimint/decline',
    redirect: { name: 'Overview', query: { paymentResult: 'decline' } },
    beforeEnter: ifAuthenticated
  },
  {
    path: '/api',
    name: 'Api',
    component: Api,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Auth,
    redirect: { name: 'Login' },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: AuthLogin,
        beforeEnter: ifNotAuthenticated
      },
      {
        path: 'registration',
        name: 'Registration',
        component: AuthRegistration,
        beforeEnter: ifNotAuthenticated
      },
      {
        path: 'confirm',
        name: 'ConfirmEmail',
        component: ConfirmEmail,
        beforeEnter: ifNotAuthenticated
      },
      {
        path: 'errors',
        name: 'ErrorComponents',
        component: AuthErrorComponents,
        beforeEnter: ifNotAuthenticated
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: AuthForgotPassword,
        beforeEnter: ifNotAuthenticated
      },
      {
        path: 'reset-password/success',
        name: 'ResetPasswordSuccess',
        component: AuthResetPasswordSuccess,
        beforeEnter: ifNotAuthenticated
      },
      {
        path: 'reset-password',
        name: 'ResetPassword',
        component: AuthResetPassword,
        beforeEnter: ifNotAuthenticated
      },
      {
        path: 'two-factor',
        name: 'TwoFa',
        component: AuthTwoFa,
        beforeEnter: ifNotAuthenticated
      }
    ]
  },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: Login,
  //   beforeEnter: ifNotAuthenticated
  // },
  // {
  //   path: '/registration',
  //   name: 'Registration',
  //   component: Registration,
  //   beforeEnter: ifNotAuthenticated
  // }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
